<template>
  <div class="milepost">
    <div class="header">
      <div class="title">畅月里程碑</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item">
          <div class="top" v-for="item in milepostTopList" :key="item.id">
            <div class="date">{{ item.date }}</div>
            <div class="text">{{ item.text }}</div>
            <div class="top-line" :class="item.id == 4 ? 'top-active' : ''">
              <div class="yuan"></div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="bottom" v-for="item in milepostBottomList" :key="item.id">
            <div class="date">{{ item.date }}</div>
            <div class="text">{{ item.text }}</div>
            <div class="bottom-line" :class="item.id == 1 ? 'bottom-active' : ''">
              <div class="yuan"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

export default {
  setup() {
    return reactive({
      milepostTopList: [
        {
          id: 1,
          date: "2012",
          text: "成功实施多项知名企业大型网络机房系统工程项目",
        },
        {
          id: 2,
          date: "2013",
          text: "建立在安防领域具有深厚技术力量的专业队伍，实施宝山第一个封闭式小区管理智能化小区",
        },
        {
          id: 3,
          date: "2014",
          text: "致力于将“何伟安防”打造成上海地区安防行业著名品牌",
        },
        {
          id: 4,
          date: "2015",
          text: "成立畅居通信公司、并聚集各类技术人才，组建专业设计、施工及服务的团队，实施宝山区农村治安联网智能门禁",
        },
      ],
      milepostBottomList: [
        {
          id: 1,
          date: "2022",
          text: "物联网设备对接移动软件，打造智慧社区、智慧物业管理系统",
        },
        {
          id: 2,
          date: "2020",
          text: "上海畅居智慧信息技术有限公司荣获五星售后服务体系认证证书、政府采购优秀供应商、高新技术企业等称号，并通过ISO9001国际质量体系认证等多项国内权威认证",
        },
        {
          id: 3,
          date: "2017",
          text: "以细节、诚信走出上海，参与全国众多品牌汽车行业的智能系统及多个重点政府实施项目建设，与各大厂商签订战略合作，为企业发展创造良好的业绩",
        },
        {
          id: 4,
          date: "2016",
          text: "顺利进行宝山区雪亮工程、农村治安防范等多个政府项目建设、并于同年建设高效、专业的售后服务体系，售后管理平台上线",
        },
      ],
    });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .milepost {
    min-width: 1180px;
  }
}
.milepost {
  width: 100%;
  height: 643px;
  background-image: url(../../../assets/about/milepostBack.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.header .title {
  font-size: 30px;
  text-align: center;
  margin-top: 80px;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  width: 1180px;
  margin: 60px auto 0;
}
.body .list .item {
  display: flex;
  justify-content: space-between;
}
.body .list .item .top {
  width: 165px;
  height: 126px;
  padding: 20px;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-bottom: 20px;
  position: relative;
  border-radius: 6px 6px 6px 6px;
}
.body .list .item .top .top-line {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 18px;
  height: 75px;
  background-color: #fff;
  position: absolute;
  top: -17%;
  right: 0;
  transform: rotate(-90deg);
}
.body .list .item .top .top-active {
  top: 70%;
  transform: rotate(0);
}
.body .list .item .top .top-line .yuan {
  width: 14px;
  height: 14px;
  background: #52809d;
  border-radius: 50%;
}

.body .list .item .bottom {
  width: 165px;
  height: 126px;
  padding: 20px;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  border-radius: 6px 6px 6px 6px;
}
.body .list .item .bottom .bottom-line {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 18px;
  height: 75px;
  background-color: #fff;
  position: absolute;
  top: -17%;
  left: 0;
  transform: rotate(-90deg);
}
.body .list .item .bottom .bottom-active {
  display: none;
}
.body .list .item .bottom .bottom-line .yuan {
  width: 14px;
  height: 14px;
  background: #52809d;
  border-radius: 50%;
}

.body .list .item .top .date,
.body .list .item .bottom .date {
  font-size: 16px;
  color: #248efb;
}
.body .list .item .top .text,
.body .list .item .bottom .text {
  font-size: 12px;
  color: #3d3d3d;
  margin-top: 10px;
}
</style>
